import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import useToast from "../useToast";

export const useAutoSelectLineup = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const toast = useToast();
  const apiUrl = process.env.REACT_APP_API_URL;

  return useMutation(
    async ({ eventId, eventName, leagueId }) => {
      const token = await getAccessTokenSilently();
      const response = await axios.post(
        `${apiUrl}/api/lineup/auto-select-lineups`,
        { eventId: String(eventId), eventName, leagueId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    },
    {
      onSuccess: (data) => {
        toast.success("Auto-select lineups created and scored successfully!");
        // Invalidate related queries to refresh data
        queryClient.invalidateQueries("lineupSubmissions");
        queryClient.invalidateQueries("leagueDetails");
        queryClient.invalidateQueries("leagueMembers");
      },
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred during auto-select lineup creation.";
        toast.error(errorMessage);
        console.error(
          "Error in auto-select lineup creation:",
          error.response ? error.response.data : error
        );
      },
    }
  );
};
